import enviroment from '../config/service.json';

export const SiteConfig = Object.seal({
  brand: '',
  configure(json: any) {
    this.brand = json.brand;
  },
});

export async function configureMap(): Promise<any> {
  const config = await fetch('/config.json', {
    cache: 'no-store',
  });
  const json = await config.json();
  return json;
}

export async function generateUrl(
  layer: string,
  key?: string,
  queryParams?: string,
) {
  const config = await configureMap();
  let apiBaseUrl: string;
  const env: any = enviroment;
  switch (layer) {
    case 'GetAvailableDataFeed':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'addUserFeed':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'getDataFeedByID':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      key = key;
      break;
    case 'updateUserFeed':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'disabledAllDataFeeds':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'sources':
      apiBaseUrl = config.operator_ApiBaseUrl;
      break;
    case 'GetSubscribedDataFeed':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'GetUpdatedDataFeed':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'userProfile':
      apiBaseUrl = config.public_userB2CProfile;
      break;
    case 'updateUserProfile':
      apiBaseUrl = config.public_userB2CProfile;
      break;
    case 'confirmSubscription':
      apiBaseUrl = config.public_subscriptionApiBaseUrl;
      break;
    case 'cancelSubscription':
      apiBaseUrl = config.public_subscriptionApiBaseUrl;
      break;
    case 'deleteUserAccount':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'getAreaList':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'downloadDataFeed':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
      break;
    case 'approveSubscriber':
      apiBaseUrl = config.public_DataFeedApiBaseUrl;
  }
  return `${apiBaseUrl + env[layer].endPoint + (key ? key : '')}${
    queryParams ? queryParams : ''
  }`;
}

export const configureSite = async (): Promise<void> => {
  const response = await fetch('./config.json', {
    cache: 'no-store',
  });
  const json = await response.json();
  SiteConfig.configure(json);
};

export const getUserType = () => {
  return fetch('./config.json', {
    cache: 'no-store',
  });
};
